import { useSyncExternalStore } from 'react';
import onboardingTourService from '../services/onboardingTourService';

export function useOnboardingTour() {
  return useSyncExternalStore(
    onboardingTourService.subscribe,
    onboardingTourService.getSnapshot,
    onboardingTourService.getSnapshot,
  );
}

export default useOnboardingTour;
